import React from 'react';

const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const ClassSchedule = ({ classItem }) => {
  if (!classItem) return <p>No class selected.</p>;

  // Get schedule array (default to empty)
  const schedule = classItem.schedule || [];

  // Group sessions by day for easier display
  const sessionsByDay = {};
  daysOfWeek.forEach(day => { sessionsByDay[day] = []; });
  schedule.forEach(session => {
    if (session.day && sessionsByDay[session.day]) {
      sessionsByDay[session.day].push(session);
    }
  });

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Weekly Schedule – {classItem.subject} ({classItem.grade})</h3>
      <div className="grid grid-cols-5 gap-4">
        {daysOfWeek.map((day) => {
          const daySessions = sessionsByDay[day] || [];
          const hasSessions = daySessions.length > 0;

          return (
            <div key={day} className="border border-green-500 rounded-lg p-3">
              <h4 className="font-bold mb-3 text-center">{day}</h4>
              {hasSessions ? (
                <div className="space-y-2">
                  {daySessions.map((session, idx) => (
                    <div key={idx} className="p-2 bg-gray-100 rounded">
                      <p className="font-medium">{classItem.subject}</p>
                      <p className="text-sm text-gray-600">Start: {session.startTime}</p>
                      <p className="text-sm text-gray-600">Duration: {session.duration} mins</p>
                      {classItem.googleClassroomLink && (
                        <a
                          href={classItem.googleClassroomLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-blue-600 hover:underline block mt-1"
                        >
                          Google Classroom
                        </a>
                      )}
                      {classItem.zoomLink && (
                        <a
                          href={classItem.zoomLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-blue-600 hover:underline block mt-1"
                        >
                          Zoom Link
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400 text-center">No class</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClassSchedule;